import api from "../shared/AxiosConfig";

export async function exportEntityToExcel(config, filters) {
    if (!config.exportEndpoint) {
        throw new Error("Export endpoint not configured");
    }
    const cleaned = Object.fromEntries(
        Object.entries(filters || {}).filter(([, v]) => v != null && v !== "")
    );
    const params = { ...cleaned, limit: 10000 };
    const res = await api.get(config.exportEndpoint, {
        params,
        responseType: "blob",
    });

    const contentDisposition = res.headers["content-disposition"];
    let filename = "export.xlsx";
    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
        if (match) filename = match[1];
    }

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

export async function fetchEntityList(config, { page, limit, filters }) {
    const params = {
        page,
        limit,
        ...filters
    };

    const res = await api.get(config.endpoint, { params });

    return {
        data: res.data?.data || res.data?.items || [],
        pagination: res.data?.pagination || {
            page: page,
            limit: limit,
            total: res.data?.total || 0,
            totalPages: Math.ceil((res.data?.total || 0) / limit)
        }
    };
}
